import './style.scss'
import moment from 'moment'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { message } from 'antd';
import StateTypes from '../../constants/StateTypes';
import dayjs from 'dayjs'
const userInfoType = StateTypes.app.customers.userInfo;
/**
 * Customer component.
 * Includes how a customer is listed on the customer sidebar
 */

const taskTypeMap = {
	defloss: '视频定损',
	survey: '视频查勘'
}
class Customer extends Component {
	constructor(props) {
		super(props)
		this.state = {
			waitTime: '',
			isPromptShow: false
		}
	}

	componentDidMount() {
		this.updateWaitTime()
	}

	componentWillUnmount() {
		clearTimeout(this.timeout)
	}

	updateWaitTime() {
		const { customer, handleCancelServiceRequest } = this.props

		var localTimestamp = moment.utc(customer.createdAt).toDate()
		var createdAt = moment(localTimestamp)
		var currentTime = moment(new Date())
		var waitTime = Math.round(moment.duration(currentTime.diff(createdAt)).asMinutes())

		if (waitTime > 120) {
			handleCancelServiceRequest(customer._id)
		}

		this.setState({ waitTime })

		this.timeout = setTimeout(this.updateWaitTime.bind(this), 10000)
	}

	handleClickCustomerPre() {
		const { customer, handleClickCustomer, actions, currentSession } = this.props
		this.props.actions.clearChatMessage()
			if (currentSession && currentSession.length > 0) {
				message.info('正在会话中...')
				return
			}
			actions.getLatestReport(customer.userInfo.flowId)
			handleClickCustomer(customer._id)

			actions.getCurrentReport(customer.userInfo.flowId)
			this.props.history.push(`/workBench/ReportDetail/${customer.userInfo.flowId}`);
			// 调用SessionAction组件的toggleSession方法
			window.postMessage({ security: true, eventName: 'toggleSession' }, '*')
	}

	handleCancelServiceRequestPre() {
		const { customer, handleCancelServiceRequest, actions } = this.props
		actions.isOrNoUserInfo(userInfoType.noneUserInfo)

		handleCancelServiceRequest(customer._id)
	}

	closeModal() {
		this.setState({
			isPromptShow: false
		})
	}

	render() {
		const { customer } = this.props
		let timeHour = '', timeYear = '', timeDiv
		if (customer && customer.userInfo.createdAt) {
			timeHour = moment(customer.userInfo.createdAt).format('HH:mm')
			timeYear = moment(customer.userInfo.createdAt).format('MM/DD')
		}
		if (timeYear && timeHour) {
			timeDiv = <div className="time-div-history" style={{ marginTop: '13px' }}>{timeYear + ' ' + timeHour}</div>
		}

		return (
			// 重写
			<li
				className="list-item"
			>
				<h4>
					<span className="name">{customer.userInfo.carOwner}</span>
					<span className="number">{customer.userInfo.flowId}</span>
				</h4>
				<p>{taskTypeMap[customer.userInfo.taskType]}</p>
				<p className="time">{dayjs(customer.createdAt).format("MM-DD HH:mm:ss")}</p>
				<a className="call-btn" onClick={this.handleClickCustomerPre.bind(this)}><i className="iconfont icon-call-full"></i></a>
			</li>
		);
	}
}

/**
 * Props that Customer component expects to be passed.
 */
Customer.propTypes = {
	handleClickCustomer: PropTypes.func.isRequired,
	// Customer object
	customer: PropTypes.object.isRequired
}

/**
 * Default props when Customer isn't passed an optional prop.
 */
Customer.defaultProps = {
	customer: {}
}

export default withRouter(Customer)
